module.exports = __webpack_public_path__ + "img/help-icon-active.5889060e.svg";